// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import useWindowDimensions from './useWindowDimensions'


interface IScreenOrientation {
  classes: string []
}


const useScreenOrientation: () => IScreenOrientation = () => {
  const {width, height} = useWindowDimensions()
  const orientation: string[] = []
  if (width > height) {
    orientation.push("landscape")
    if (width >= 1024 && height > 600) {
      orientation.push("large")
    }
    if (height <= 600) {
      orientation.push("constrained-height")
    }
  } else {
    orientation.push("portrait")
    if (width > 768) {
      orientation.push("large")
    }
  }

  if (width < 300) {
    orientation.push("constrained-width")
  }

  return {
    classes: orientation.map((name) => `screen-${name}`)
  }
}

export {
  useScreenOrientation,
}